import { IEmailTemplatePreview } from "./email-template-preview";

export interface IEmailTemplatePreviewResponse {
    data: {
        success: boolean;
        message: string;
        results: IEmailTemplatePreview
    }
}